<template>
  <div>
    <div class="border border-solid border-gainsboro rounded-lg p-[24px] bg-white mt-6">
      <p class="text-2xl text-young-night mb-[24px]">{{ 'API Keys' }}</p>
      <div v-if="!apiKey" class="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <p>{{ $t('You don’t have any API Key yet.') }}</p>
        <vs-alert class="mb-base" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" v-if="merchantStatus === 'on_hold'">
          {{$t('Your account is')}} <b>{{$t('On hold')}}</b> {{$t('due to inactivity. Please, use the chat icon to talk to our support team and reactivate your account.')}}
        </vs-alert>   
        <div v-else class="md:flex-grow-0 flex-grow">
          <shipblu-button id="new-btn-loading" class="rounded vs-con-loading__container md:w-auto w-full" size="small" :disabled="merchant.is_self_signup && merchant.name === 'Entrepreneur Merchant'" :textButton="$t('Generate API Key')" @click="newAPIKey('post')"/>
        </div>
      </div>
      <div v-if="apiKey" class="flex md:flex-row flex-col lg:items-center justify-between gap-6">
        <div class="flex md:items-center gap-3 flex-grow">
          <input :type="visible ? 'password' : 'text'" class="p-[12px] leading-[20px] bg-[#F1F1F1] border-0 rounded-md lg:w-[400px] w-full text-[14px] truncate" v-model="apiKey" readonly/>
          <shipblu-icon @click="visible = !visible" iconLibrary="material" :iconName="visible ? 'visibility' : 'visibility_off'" iconClass="text-[#BFBFBF] text-[24px] select-none cursor-pointer"/>
          <shipblu-icon @click="common.copied(apiKey)" iconLibrary="material" iconName="content_copy" iconClass="text-[#BFBFBF] text-[24px] select-none hover:text-primary cursor-pointer" />
        </div>
        <div class="flex items-center gap-2 md:flex-grow-0 flex-grow">
          <shipblu-button id="new-btn-loading" class="rounded vs-con-loading__container flex-grow" :textButton="$t('Regenerate API Key')" @click="reNewAPIKey()"/>
          <shipblu-button id="delete-btn-loading" class="rounded vs-con-loading__container flex-grow" color="danger" :textButton="$t('Delete API key')" @click="deleteAPIKey()"/>
        </div>
      </div>
    </div>

    <div class="border border-solid border-gainsboro rounded-lg p-[24px] bg-white mt-10">
      <p class="text-2xl text-young-night">{{ $t('Integrate ShipBlu with your store') }}</p>
      <div class="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 mt-4">
        <div class="flex flex-col items-center gap-5">
          <img class="ml-auto mr-auto " src="../../../assets/images/pages/shopify.jpg"/>
          <a class="underline text-lg block text-center" :href="$route.params.lang === 'en' ? 'https://support.shipblu.com/en/support/solutions/articles/154000217447-shopify' : 'https://support.shipblu.com/ar/support/solutions/articles/154000217447-%D8%B4%D9%88%D8%A8%D9%8A%D9%81%D8%A7%D9%8A'" target="blank">{{ $t('Learn how') }}</a>
        </div>
        <div class="flex flex-col items-center gap-5">
          <img class="ml-auto mr-auto" src="../../../assets/images/pages/woo-commerce.png"/>
          <a class="underline text-lg block text-center" :href="$route.params.lang === 'en' ? 'https://support.shipblu.com/en/support/solutions/articles/154000222386-woocommerce' : 'https://support.shipblu.com/ar/support/solutions/articles/154000222386-%D9%88%D9%88%D9%83%D9%88%D9%85%D8%B1%D8%B3'" target="blank">{{ $t('Learn how' )}}</a>
        </div>
        <div class="flex flex-col items-center gap-5">
          <img class="ml-auto mr-auto" height="200" width="200" src="../../../assets/images/pages/zammit.svg"/>
          <a class="underline text-lg block text-center" :href="$route.params.lang === 'en' ? 'https://support.shipblu.com/en/support/solutions/articles/154000223217-zammit' : 'https://support.shipblu.com/ar/support/solutions/articles/154000223217-%D8%B2%D8%A7%D9%85%D8%AA'" target="blank">{{ $t('Learn how') }}</a>
        </div>
        <div class="flex flex-col items-center gap-5">
          <img class="ml-auto mr-auto" src="../../../assets/images/pages/magento.png"/>
          <a class="underline text-lg block text-center" :href="$route.params.lang === 'en' ? 'https://support.shipblu.com/en/support/solutions/articles/154000223977-magento' : 'https://support.shipblu.com/en/support/solutions/articles/154000223977-magento'" target="blank">{{ $t('Learn how') }}</a>
        </div>
      </div>        
    </div>
  </div>
</template>

<script>
import common from '../../../assets/utils/common'
import { sendRequest } from '../../../http/axios/requestHelper'
import i18nData from '../../../i18n/i18nData'

export default {
  props: ['merchantStatus'],
  data () {
    return {
      common,
      merchantID: '',
      apiKey: '',
      apiKeyLoading: false,
      merchant: {},
      visible: true
    }
  },
  methods: {
    newAPIKey () {
      this.apiKeyLoading = true
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#new-btn-loading',
        scale: 0.45
      })
      sendRequest(true, false, this, 'api/v1/merchant-api-keys/', 'post', {}, true, 
        (response) => {
          this.apiKey = response.data.API_Key
          this.apiKeyLoading = false
          this.$vs.loading.close('#new-btn-loading > .con-vs-loading')
          const user = JSON.parse(localStorage.getItem('merchant'))
          localStorage.removeItem('merchant')
          user.api_key = response.data.API_Key
          localStorage.setItem('merchant', JSON.stringify(user))
          this.$emit('APIKey', this.apiKey)
        }, (error) => {
          common.notifyResponseError(this, error)
          this.apiKeyLoading = false
          this.$vs.loading.close('#new-btn-loading > .con-vs-loading')
        }
      )
    },
    reNewAPIKey () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#new-btn-loading',
        scale: 0.45
      })
      sendRequest(true, false, this, 'api/v1/merchant-api-keys/', 'patch', {}, true,
        (response) => {
          this.apiKey = response.data.API_Key
          this.apiKeyLoading = false
          this.$vs.loading.close('#new-btn-loading > .con-vs-loading')
          const user = JSON.parse(localStorage.getItem('merchant'))
          localStorage.removeItem('merchant')
          user.api_key = response.data.API_Key
          localStorage.setItem('merchant', JSON.stringify(user))
          this.$emit('APIKey', this.apiKey)
        }
      )
    },
    deleteAPIKey () {
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#delete-btn-loading',
        scale: 0.45
      })
      sendRequest(true, false, this, 'api/v1/merchant-api-keys/', 'delete', null, true, 
        (response) => {
          this.apiKey = response.data.API_Key
          const user = JSON.parse(localStorage.getItem('merchant'))
          user.api_key = ''
          this.$emit('APIKey', '')
          localStorage.setItem('merchant', JSON.stringify(user))
          this.$vs.loading.close('#delete-btn-loading > .con-vs-loading')
        }
      )
    }
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    merchantData.then(results => {
      this.merchant = results.merchantData
      this.apiKey = this.merchant.api_key
      this.$emit('APIKey', this.apiKey)
    })
  }
}
</script>
<style></style>